import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type ImageChoiceType = {
  outerDiv: CSSProperties;
  imageContainer: CSSProperties;
};

export const imageChoiceStyles: ImageChoiceType = {
  outerDiv: {
    ...cssClass.outerDiv,
    ...cssClass.boxShadow,
    padding: "0",
    backgroundColor: backgroundColors.white,
  },

  imageContainer: {
    ...cssClass.textContainerBase,
  },
};
